import { apiFetch } from "./client";

/** Keys for the quote API and MCP server, plus recent activity and the base URL. */
export function listApiKeys() {
  return apiFetch("/api/admin/api-keys");
}

/** Returns the new key once ({..., key}); it's never shown again. */
export function createApiKey(name) {
  return apiFetch("/api/admin/api-keys", { method: "POST", body: { name } });
}

export function revokeApiKey(id) {
  return apiFetch(`/api/admin/api-keys/${id}`, { method: "DELETE" });
}
